module.exports = __webpack_public_path__ + "static/media/ShoppingCartIcon.18d4cb66.svg";